import React, { Component } from "react";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";

/**
 * Displays an input to allwo filter by a single value
 * @param {*} props
 */
class LogicalOperatoInputValue extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          value: "",
        };
  }

  onChange = (event) => {
    this.setState({ value: event.target.value });
  };

  /**
   * Set the value in the current Filter
   */
  onApplyFilter = () => {
    this.props.onApplyFilter(this.state);
  };

  render() {
    return (
      <>
        <div className="p-2 filter-container">
          <div className="input-group">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Input a value"
              value={this.state.value}
              onChange={this.onChange}
            />
          </div>
        </div>
        <FilterSelectAddFilterButton
          disabled={this.state.value.trim().length === 0}
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatoInputValue;
